import { WORLDS } from "@/worlds";
export type ConnectionStatus =
  | "idle"
  | "connecting"
  | "connected"
  | "reconnecting"
  | "disconnected";

export type StreamState = "idle" | "buffering" | "streaming";

export interface Resolution {
  width: number;
  height: number;
}

export interface SceneReference {
  sceneId: string;
  //TODO: hide scene types from client?
  sceneType: "marble" | "dl3dv" | "slam";
  collisionId?: string;
}

export interface CarouselWorld {
  name: string;
  thumbnail: string;
  scene?: SceneReference;
}

//state updated from dispatchAppState, connects the vanillaJS and react state
export interface RtfmAppState {
  gatewayErrors: number;
  connectionStatus: ConnectionStatus;
  streamState: StreamState;
  viewportMode: "fit" | "native";
  resolution: Resolution;
  fps: number;
  steps: 1 | 5;
  lastFrameAt: number | null;
  error: string | null;
  queueStatus: "initial" | "queued" | "allocated" | "active" | "expired" | "not_found";
  queuePosition: number;
  sceneSelectionLocked: boolean;
  allowSceneSelection: boolean;
  allowRequeue: boolean;
  badConnection: boolean;
  worldsList: Record<string, CarouselWorld>;
  sceneLoadStatus: SceneLoadStatus;
  sceneLoadError: string | null;
  currentWorldId: string | null;
  loadingWorldId: string | null;
  cursorLocked: boolean;
  consoleVisible: boolean;
}

export type RtfmAppStateUpdate = Partial<RtfmAppState>;

export type SceneLoadStatus = "idle" | "loading" | "error";

type AppStateEventDetail = {
  kind: "state";
  payload: RtfmAppStateUpdate;
};

export const APP_STATE_EVENT = "rtfm:app:state";

declare global {
  interface Window {
    __rtfmAppStateTarget?: EventTarget;
  }
}

function getEventTarget(): EventTarget {
  if (typeof window === "undefined") {
    return new EventTarget();
  }
  if (!window.__rtfmAppStateTarget) {
    window.__rtfmAppStateTarget = new EventTarget();
  }
  return window.__rtfmAppStateTarget;
}

export const eventTarget = getEventTarget();

export function dispatchAppState(update: RtfmAppStateUpdate) {
  // console.log("dispatchAppState", update);
  const detail: AppStateEventDetail = { kind: "state", payload: update };
  eventTarget.dispatchEvent(
    new CustomEvent<AppStateEventDetail>(APP_STATE_EVENT, { detail }),
  );
}
